import { schema } from 'normalizr';

export const practitionerSchema = new schema.Entity('practitioners');
export const practitionersListSchema = new schema.Array(practitionerSchema)
